module.exports = __webpack_public_path__ + "media/images/telefono_corona-a178ee8ec0e7f63d23a0f18adf2c90b1.jpg";